import AboutMe from "./HomeComps/AboutMe";
import AskFriends from "./HomeComps/AskFriends";
import Footer from "./HomeComps/Footer";
import Hero from "./HomeComps/Hero";
import FeaturedWork from "./HomeComps/FeaturedWork";
import NeramSection from "./HomeComps/Neram";
import TechSkills from "./HomeComps/TechSkills";
import TimeLine from "./HomeComps/TimeLine";
import WaveSVG from "./HomeComps/WavesSvg/Wavesvg";

export const Home = () => {
  return (
    <>
      <Hero />
      <NeramSection />
      <AboutMe />
      <FeaturedWork />
      {/* White wave merges Featured Work's gradient down into the white Tech Skills section */}
      <WaveSVG />
      <TechSkills />
      <AskFriends />
      <TimeLine />
      <Footer />
    </>
  );
};
